import { useMediaQuery as _useMediaQuery } from 'react-responsive';
import { rem } from 'polished';

import { makeTheme, onMedia, media, reducedMotion } from '../theme';

import type { CustomTheme, MediaSelector } from '../theme';
import { Theme } from '@emotion/react';

export const defaultTheme: Theme = Object.freeze({
  navigationHeight: rem(77),
  typography: {
    eventHeader: {
      fontFamily: '"Cafe24Danjunghae__subset", Cafe24Danjunghae, sans-serif',
      fontWeight: 400,
      ':lang(ja), :lang(zh-Hant)': {
        fontFamily: 'inherit',
        fontWeight: 700,
      },
    },
    cartoonStyleText: {
      fontFamily: '"CookieRun__subset", CookieRun, sans-serif',
      fontWeight: 700,
      ':lang(ja), :lang(zh-Hant)': {
        fontFamily: 'inherit',
        fontWeight: 700,
      },
    },
  },
  media,
  onMedia,
  reducedMotion,
});

export const { styled, ThemeProvider, useTheme } = makeTheme<Record<string, unknown>, CustomTheme>(defaultTheme);

const MEDIA_QUERY_VALUE_REGEXP = /^@media (\(.*\))$/;

const toUseMediaQueryParam = (media: MediaSelector) => ({
  query: media.replace(MEDIA_QUERY_VALUE_REGEXP, '$1'),
});

export function useMediaQuery(media: MediaSelector): boolean {
  return _useMediaQuery(toUseMediaQueryParam(media));
}

export function useMediaValue<T = any>(values: readonly [T, T] | readonly [T, T, T] | readonly [T, T, T, T]) {
  const theme = useTheme();
  const sm = useMediaQuery(theme.media.sm);
  const md = useMediaQuery(theme.media.md);
  const lg = useMediaQuery(theme.media.lg);
  const breaks = [sm, md, lg].filter(Boolean);
  return values[Math.min(breaks.length, values.length - 1)];
}
